import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { Switch } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const SpacePicker = {
  Type: "spacePicker",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: SpacePicker.Type,
      selectedGoto: "",
      locationCodeVariableId: "LocationId",
      notSelectedGoto: "",
      searchDifferentStoreGoto: "",
      noUnitsGoto: "",

      // New fields for unhandled toggle
      handleFreeText: false, // Default to off to maintain current behavior
      freeTextGoto: "" // New goto for unhandled text
    };
    return node; //
  },
  PlumbData: function (node: NodeInterface) {
    const tabs = [
      {
        id: "selectedGoto",
        source: "selectedGoto",
        target: node.selectedGoto,
        title: "Unit Selected"
      },
      {
        id: "notSelectedGoto",
        source: "notSelectedGoto",
        target: node.notSelectedGoto,
        title: "No Unit Selected"
      },
      {
        id: "noUnitsGoto",
        source: "noUnitsGoto",
        target: node.noUnitsGoto,
        title: "No Units Available"
      },
      {
        id: "searchDifferentStoreGoto",
        source: "searchDifferentStoreGoto",
        target: node.searchDifferentStoreGoto,
        title: "Search Different Store"
      }
    ];

    // Add Unhandled tab if handleFreeText is enabled
    if (node.handleFreeText) {
      tabs.push({
        id: "freeTextGoto",
        source: "freeTextGoto",
        target: node.freeTextGoto,
        title: "Unhandled"
      });
    }

    return TabNodeLayoutData({
      node: node,
      title: "Get Store Units",
      body: node.text || "",
      baseWidth: 170,
      tabs: tabs
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    render() {
      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Get Store Units" />
            <label>Store Location Code</label>
            <UserVariablesDropdown
              onChange={this.onChange}
              skipUserId={true}
              name={"locationCodeVariableId"}
              value={this.props.node.locationCodeVariableId}
            />

            {/* New unhandled toggle - same label and styling as ProfileCollect */}
            <label>Unhandled Output</label>
            <Switch
              name="handleFreeText"
              on={this.props.node.handleFreeText}
              onSet={(on, name) => {
                let node = JSON.parse(JSON.stringify(this.props.node));
                node[name!] = on;
                this.props.updateNode(node, this.props.node, true);
              }}
            />
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default SpacePicker;
